/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Aashish Singh, Created Date: 04-July-2025
</summary>
*/
enum fotaViewTypeEnum{
    Host=0,
    Jet=1,
    Modem=2,
}

export enum ModuleToOpen{
    Config=0,
    Schedule=1,
}

export default fotaViewTypeEnum